<template>
  <editor-wrap ref="editor-wrapper" :editor-api="this.editorApi" :editor-id="this.editorId" :config="{ id: 'stock' }">
    <template v-slot="{disabledNext, onNext, onPrevious, disabledPrev, current, total, onClose}">
      <editor
        :disabled="isDisabledForm"
        :config="editorConfig"
        @on-quick-rfq="onQuickRFQ"
        @on-close="onClose"
        @onDuplicateSuccess="onDuplicateSuccess"
      >
        <div class="d-flex justify-content-between align-items-center">
          <div v-if="total" class="d-flex flex-nowrap">
            <div class="control btn-mobile-full mb-3 mr-2">
              <button class="btn btn-size-s btn-white" :disabled="disabledPrev" @click="onPrevious">
                {{L10n('previous')}}
              </button>
            </div>
            <div class="control btn-mobile-full mb-3 ml-2" >
              <button class="btn btn-size-s btn-white" :disabled="disabledNext" @click="onNext">
                {{L10n('next')}}
              </button>
            </div>
          </div>
          <div class="pager blue-text">
            <span>{{current}}</span> / <span>{{total}}</span>
          </div>
        </div>
      </editor>
    </template>
  </editor-wrap>
</template>

<script>

export default {
  name: 'StockEditorWrapper',
  components: {
    'editor': () => import(/* webpackChunkName: 'Stock' */ './Editor'),
    'editor-wrap': () => import(/* webpackChunkName: 'Shared' */ '@/components/Shared/Stock')
  },
  props: {
    isDisabledForm: {
      type: Boolean,
      required: true
    },
    editorApi: {
      type: String,
      required: true
    },
    editorId: { type: String, required: true },
    onQuickRFQ: {
      type: Function,
      required: true
    }
  },
  computed: {
    editorConfig () {
      return {
        id: this.editorId,
        api: this.editorApi
      }
    }
  },
  methods: {
    async onDuplicateSuccess ({ data, isShowAfterCreate }) {
      const editorWrapper = this.$refs['editor-wrapper']
      if (!editorWrapper) return

      await editorWrapper.onRefresh()

      if (isShowAfterCreate) {
        const index = editorWrapper.moreStocks.findIndex(({ id }) => id === data.id)

        if (index === -1) return

        editorWrapper.onChangeValue(index)
      }
    }
  }
}
</script>
<style scoped>
  .pager{
    font-weight: bold;
    font-size: 2rem;
    margin-left: auto;
  }
</style>
